module.exports = __webpack_public_path__ + "media/site_templates/www.mulchingservices.net.au/images/our_services_3-68eeb59a6f666a3c22b26b861a32d772.jpg";